import { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash.debounce';
import { useSearchTransaction } from '../api/searchTransaction';

export const useTransactionSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const {
    data: transactionSearchQueryData,
    isLoading: isTransactionSearchLoading,
    refetch: refetchTransactions,
  } = useSearchTransaction({
    text: searchTerm.trim().length > 0 ? searchTerm : null,
  });

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setSearchResults([]); // Reset when input is cleared
    } else if (transactionSearchQueryData?.transactions) {
      setSearchResults(transactionSearchQueryData.transactions);
    }
  }, [transactionSearchQueryData]);

  const handleSearch = useCallback(
    debounce((query) => {
      setSearchTerm(query);
      if (query.trim() === '') {
        setSearchResults([]); // Reset results when input is empty
      } else {
        refetchTransactions();
      }
    }, 300),
    []
  );

  return { searchTerm, searchResults, isTransactionSearchLoading, handleSearch };
};
